module.exports = __webpack_public_path__ + "static/media/clutchLogin.9b14fa1d.webp";